<div class="wrapup-page">

  <!-- Header -->
  <div class="wrapup-header">
    <div class="wrapup-header-inner">
      <div class="wrapup-header-left">
        <p class="wrapup-system-label">TASK MANAGEMENT SYSTEM</p>
        <h1 class="wrapup-title">{{ isCatchUpSignOff ? ('Wrap Up ' + catchUpDayLabel + ' Before You Continue') : 'Sign Off — Wrap Up Your Day' }}</h1>
      </div>
      <button class="wrapup-close-btn" mat-icon-button *ngIf="!isCatchUpSignOff && !isFromLock" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Scrollable body -->
  <div class="wrapup-body">

    <!-- Tasks Due Today -->
    <section class="wrapup-section">
      <div class="wrapup-section-header">
        <h2 class="wrapup-section-title">{{ isCatchUpSignOff ? ('Tasks Due ' + catchUpDayLabel) : 'Tasks Due Today' }}</h2>
        <button mat-button class="wrapup-select-all-btn" (click)="selectAllTasks()">
          Select all &amp; complete
        </button>
      </div>

      <!-- Loading -->
      <div class="wrapup-empty-state" *ngIf="tasksLoading">
        <mat-icon class="wrapup-empty-icon">hourglass_empty</mat-icon>
        <p>Loading tasks...</p>
      </div>

      <!-- Empty state -->
      <div class="wrapup-empty-state" *ngIf="!tasksLoading && tasks.length === 0">
        <mat-icon class="wrapup-empty-icon">task_alt</mat-icon>
        <p>No tasks due today.</p>
      </div>

      <div class="wrapup-task-list" *ngIf="!tasksLoading && tasks.length > 0">
        <div class="wrapup-task-card" *ngFor="let task of tasks">
          <div class="wrapup-task-row">
            <mat-checkbox
              [(ngModel)]="task.completed"
              class="wrapup-checkbox">
            </mat-checkbox>
            <div class="wrapup-task-info">
              <span class="wrapup-task-name" [class.completed]="task.completed">
                {{ task.name }}
              </span>
              <span class="wrapup-task-meta">{{ task.assignedBy }} · {{ task.dueLabel }}</span>
            </div>
          </div>
          <mat-form-field appearance="fill" class="wrapup-note-field">
            <input matInput [(ngModel)]="task.note" placeholder="Optional note..." />
          </mat-form-field>
        </div>
      </div>
    </section>

    <!-- Today's Calendar Activities -->
    <section class="wrapup-section">
      <h2 class="wrapup-section-title">{{ isCatchUpSignOff ? (catchUpDayLabel + "'s Calendar Activities") : "Today's Calendar Activities" }}</h2>

      <!-- Loading -->
      <div class="wrapup-empty-state" *ngIf="calendarLoading">
        <mat-icon class="wrapup-empty-icon">hourglass_empty</mat-icon>
        <p>Loading calendar events...</p>
      </div>

      <!-- Empty state -->
      <div class="wrapup-empty-state" *ngIf="!calendarLoading && calendarEvents.length === 0">
        <mat-icon class="wrapup-empty-icon">event_busy</mat-icon>
        <p>No calendar events found for today.</p>
      </div>

      <div class="wrapup-calendar-list" *ngIf="!calendarLoading && calendarEvents.length > 0">
        <div class="wrapup-calendar-card" *ngFor="let event of calendarEvents">
          <div class="wrapup-calendar-row">
            <div class="wrapup-calendar-info">
              <span class="wrapup-calendar-name">{{ event.name }}</span>
              <span class="wrapup-calendar-time">{{ event.time }}</span>
            </div>
            <div class="wrapup-calendar-actions">
              <span class="wrapup-attendance-required" *ngIf="event.attendance === null">
                <mat-icon>error_outline</mat-icon> Required
              </span>
              <button
                mat-stroked-button
                class="wrapup-attendance-btn"
                [class.active-attended]="event.attendance === 'attended'"
                (click)="setAttendance(event, 'attended')">
                Attended
              </button>
              <button
                mat-stroked-button
                class="wrapup-attendance-btn"
                [class.active-missed]="event.attendance === 'missed'"
                (click)="setAttendance(event, 'missed')">
                Missed
              </button>
            </div>
          </div>
          <mat-form-field appearance="fill" class="wrapup-note-field">
            <input matInput [(ngModel)]="event.note" placeholder="How did it go? (Useful / Waste / Notes...)" />
          </mat-form-field>
        </div>
      </div>
    </section>

  </div>

  <!-- Footer CTA -->
  <div class="wrapup-footer">
    <button
      class="wrapup-signoff-btn"
      mat-raised-button
      type="button"
      [disabled]="!allAttendanceMarked"
      (click)="onSignOff()">
      {{ isCatchUpSignOff ? 'Continue' : 'Sign Off & End My Day' }}
    </button>
  </div>

</div>